import React from 'react';
import { IconButton, Tooltip } from '@smarterservices/smarter-ui';
import { IconTroubleLine } from '@smarterservices/smarter-ui';
import { getStore } from '../../stores/StoreContext';

const DiagnosticsButton = () => {
  const AppStore = getStore('appStore');

  const handleClick = () => {
    AppStore.openDiagnosticsModal();
  };
return null;
  return (
    <Tooltip renderTip="Session Diagnostics" placement="bottom">
      <IconButton
        size="small"
        onClick={handleClick}
        screenReaderLabel="Open Session Diagnostics"
        color="primary"
        withBackground={false}
        withBorder={false}
      >
        <IconTroubleLine />
      </IconButton>
    </Tooltip>
  );
};

export default DiagnosticsButton;
